<template lang='pug'>
.product-container
    .img-container
        img(:src="img")
    .product-right
        .content-container(@click="jump()")
            .bigName {{bigName}}
            .smallName(v-if="smallName") {{smallName}}
        .shoucang-container(v-if="type=='shoucang'" @click="jump")
            img(src="@/assets/imgs/collect@3x.png" v-if="!result" @click.stop="shoucang")
            img(src="@/assets/imgs/icon-collected-blue@3x.png" v-if="result" @click.stop="shoucang")
            .text(@click.stop="shoucang") 收藏
        .shoucang-container2(v-if="!(type=='shoucang')" @click.stop="jump") 查看详情
        
</video>


    

</template>

<script>
import {addBookmark,deleteBookmark,checkMember} from '@/service/member'
import { mapState } from 'vuex'
export default {
    props:['bigName','smallName','img','type','name','params']
,   
    data(){
        return {
            introduceDetail2:[],
            result:false,
            data:[]
        }
    },
    async created() {
              if(this.bookMarks){
                this.data=this.bookMarks
                await this.initData()
            }
         
    },
    computed:{
        ...mapState(['memberInfo','bookMarks'])
    },
    methods:{
        async shoucang(){
            const {VUE_APP_MEMBER_FORMID,VUE_APP_FORM} =window.env
            let isMember =await checkMember(true)
            if(!isMember){
               window.location.href=`${VUE_APP_FORM}${VUE_APP_MEMBER_FORMID}?redirect=${encodeURIComponent(window.location.href)}`
            }
            if(this.result){
                await deleteBookmark(this.result.id)
                await this.$store.dispatch('getBookmarks',true)
                this.data=this.$store.state.bookMarks
                await this.initData()
            }else{
                await addBookmark({
                    detail:{
                        type:'content',
                        bigName:this.bigName,
                        smallName:this.smallName,
                        name:'introduceDetail2',
                        // params:{
                            // introduceName:this.bigName,
                            // introduceName2:this.smallName
                        // },
                        params:this.params,
                        imga:this.img
                    },
                    name: this.smallName,
                    url: window.location.href
                })
                await this.$store.dispatch('getBookmarks',true)
                this.data=this.$store.state.bookMarks
                await this.initData()
            }
        },
        async initData() {
            this.introduceDetail2=[]
            this.data.forEach(val=>{
                if(val.detail.type=='content'){
                    if(val.detail.name=='introduceDetail2'){
                        this.introduceDetail2.push(val)
                    }
                }
            })
            this.result=this.introduceDetail2.find(val=>{
                return ((val.detail.bigName==this.bigName)&&(val.detail.smallName==this.smallName))
            })

        },
        jump(){
            this.$router.push({
                name:this.name,
                params:this.params
            })
        }
    }
}
</script>

<style scoped lang='less'>
.product-container{
    display: flex;
    justify-content: space-between;
    .img-container{
        width:2.4rem;
        height:2.4rem;
        margin-right:0.3rem;
        img{
            display: block;
            border-radius: 0.5rem;
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }
    .product-right{
        flex:1;
        background: #f3f3f3;
        border-radius: 0.2rem;
        padding-left:0.5rem;
        padding-right: 0.5rem;
        display: flex;
        justify-content: space-between;
        height:2.4rem;
        .content-container{
            width:80%;
            display: flex;
            height:2.4rem;
            flex-direction: column;
            justify-content: center;
            .bigName{
                color: #00448a;
                line-height: 0.9rem;
            }
            .smallName{
                color: #7b7b7b;
                font-size: 0.6rem;
                line-height: 0.85rem;
                width: 10rem;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
        .shoucang-container2{
            display: flex;
            align-items: center;
            height: 100%;
            font-size: 0.6rem;
            color: #219cdc;
        }
        .shoucang-container{
            display: flex;
            height:100%;
            align-items: center;
            img{
                width: 0.8rem;
                height:0.8rem;
                display: block;
                margin-right:0.2rem ;
            }
            .text{
                color:#0097d6;
                font-size: 0.6rem
            }
        }
    }
}
</style>